module.exports = __webpack_public_path__ + "img/kerlouan-lazy.a642f50e.jpg";